import { render, staticRenderFns } from "./IresDeviceItem.vue?vue&type=template&id=533f58e4&scoped=true&"
import script from "./IresDeviceItem.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceItem.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceItem.vue?vue&type=style&index=0&id=533f58e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f58e4",
  null
  
)

export default component.exports